define.alias("shared/components/shared/pre-boarding/auto-trial-end/index", "settings/components/shared/pre-boarding/auto-trial-end");